<template>
  <div>
    <div class="navBar " :class="bouns===true?'header_fixed':''" id="navBar">
      <header class="site-header">
        <div class="nav_top">
          <div class="nav_left">
            <ul>
              <li class="left">
                <router-link to="/">
                  <div class="optical-home">
                    <img src="../assets/img/logo.png" alt="user">
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="nav_right">
            <ul>
              <li v-for="(item, index) in functionList" data-index="index" :key="index">
                <span @click="$router.push(item.route)">{{ $t(item.title) }}</span>
              </li>
              <li>
                <a class="nav_top_icon" v-if='$i18n.locale=="en"' @click="langChanged('ch')">
                  <img src="../assets/img/icon_en.png" alt="">
                  <span class="navusername mobile_hide">English</span>
                </a>
                <a class="nav_top_icon" v-if='$i18n.locale=="ch"' @click="langChanged('en')">
                  <img src="../assets/img/icon_ch.png" alt="">
                  <span class="navusername mobile_hide">中文</span>
                </a>
              </li>
              <li>
                <router-link to="/login" class="nav_top_icon" v-if="!loggedIn">
                  <img src="../assets/img/icon_login.png" alt="user">
                  <span class="navusername">{{ $t('login/register') }}</span>
                </router-link>
                <!-- <a href="javascript:void(0);" class="user" v-if="loggedIn" @mouseover="handleAccountMouseIn($event)" @click="navToAccount('orders')"> -->
                <a href="javascript:void(0);" class="nav_top_icon" v-if="loggedIn" @mouseover="handleAccountMouseIn($event)">  
                  <img src="../assets/img/user_icon.png" alt="user">
                  <span class="navusername mobile_hide">{{this.$store.state.auth.userDetails.FirstName}}</span>
                </a>
              </li>
              <div class="account-portal-modal" v-bind:style="userIconCoordinate" v-if="showAccountPortal && loggedIn && !isMobile" @mouseleave="handleAccountMouseOut">
                <div class="modal-data-container">
                  <div class="logout" @click="navToAccount('orders')">{{ $t('account') }}</div> 
                  <div class="logout" @click="signOut">{{ $t('logOut') }}</div>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </header>
      <!--end header-->
    </div>
  </div>
</template>
<script>
import Velocity from 'velocity-animate';
import jquery from "jquery";
import { mapState, mapActions, mapMutations } from 'vuex';
import { isUserAuthenticated } from '../store/modules/cart';
import modal1 from "../view/modal"; 

var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
let $ = jquery;
import _ from 'lodash';
export default {
  name: "navbar",
  components: {
    modal1,
  },
  props: {
    group: {
      type: String,
      default: 'munchies'
    }
  },
  data() {
    return {
      // langs: ['en', 'ch'],
      phoneNav: false, // mobile group dropdown
      bouns: false,//上下滑动 添加class
      scroll: 0,//上下滑动距离
      MunchiesShow: false,//一级导航显示
      device: '',
      zipcode: '',
      local: null,
      checkoutModal: false,
      showAccountPortal: false,
      userIconCoordinate: {
        left: 0,
        top: 0,
      },
      serviceIconCoordinate: {
        left: 0,
        top: 0,
      },
      functionList: [
        { title: "header1", route: "/inbound" },
        { title: "header2", route: "/outboundInv"}, // 海外仓
        { title: "header3", route: "/outboundNoInv"}, // 卡派打單
        { title: "header4", route: "/upsFedex"}, // 快递打单
        { title: "aboutUs", oute: "/aboutUs"}, // 关于我们
      ],
      isMobile: isMobile,
    }
  },
  methods: {
    ...mapActions('auth',['fetchCustomerInformation']),
    ...mapActions('orders', ['fetchOrderByTimeFrame']),
    ...mapMutations('auth', ['logout', 'updateLoginStatus']),
    ...mapMutations('navbar', ['handleWindowResize', 'updateDevice', 'toggleModal', 'handleNavToAccountFromNavbar', 'mobileDevice']),
    handleAccountMouseIn(event) {
      this.showAccountPortal = true;
    },
    handleAccountMouseOut(event) {
      const arrOfClassName = ["account-portal-modal", "speech-bubble", "arrow", "bubble-node"];
      if(arrOfClassName.includes(event.relatedTarget.className.split(' ')[0])) {
        return;
      }
      this.showAccountPortal = false;
    },
    handleWindowChange() {
      this.handleWindowResize({
        windowWidth: document.documentElement.clientWidth,
        windowHeight: document.documentElement.clientHeight,
      });
    },
    navToAccount(target) {
      this.handleNavToAccountFromNavbar(target);
      if(this.$route.name !== 'account') { this.$router.push('/account');}
    },
    changeCoordinateOfModal() {
      this.userIconCoordinate = {
        left: document.getElementsByClassName('navusername')[0].getBoundingClientRect().x + 40 + 'px',
        top: document.getElementsByClassName('navusername')[0].getBoundingClientRect().y + 35 + 'px',
      };
      this.serviceIconCoordinate = {
        left: 100 + 'px',
        top: document.getElementsByClassName('navusername')[0].getBoundingClientRect().y + 29 + 'px',
      };
    },
    bounsShow() {
      if (this.bouns) {
        document.getElementsByTagName("body")[0].className = "body_top";
      } else {
        document.getElementsByTagName("body")[0].className = "";
      }
    },
    handleScroll() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (this.scroll > 0) {
        this.bouns = true;
        this.bounsShow()
      } else {
        this.bouns = false;
        this.bounsShow()
      }
    },
    phoneNavShow() {
      this.phoneNav = !this.phoneNav;
    },
    //Sign out User
    signOut() {
      this.logout();
    },
    tokenIsValid() {
      //send token to server see if it is still valid
      return true
    },
    validateDeliveryRadius(event) {
      const inputValue = event.target.value;
      if ((!Number.isNaN(Number(inputValue))) || inputValue === '') {
      this.zipcode = inputValue;
      }
    },
    checkForClose(event) {
      if (event === undefined) {
        this.toggleModal(false);
        // localStorage.setItem('showModalToken', false);
      }
    },
    goToLogin() {
      this.$router.push("/login");
    },
    langChanged(lang) {
      localStorage.Lang=lang;
      if(localStorage.Lang!=null) this.$i18n.locale=localStorage.Lang;
    },
  },
  beforeMount() {
    if (isUserAuthenticated()) {
      this.local = false;
    } else {
      this.local = true;
    }
    if (window.screen.width < 900) {
      //WAP and ONLINE are what Yuansfer uses to distinguish between mobile
      //and desktop devices. 
      this.updateDevice('WAP');
    } else {
      this.updateDevice('ONLINE');
    }
    if (window.screen.width <= 500) {
      this.mobileDevice(true);
    } else {
      this.mobileDevice(false);
    }
    // if (JSON.parse(localStorage.getItem('showModalToken')) !== true && JSON.parse(localStorage.getItem('showModalToken')) !== false) {
    //   localStorage.setItem('showModalToken', true);
    // }
  },
  mounted() {
    if(localStorage.getItem('token') && this.tokenIsValid(localStorage.getItem('token'))) {
      this.updateLoginStatus(true);
    };
    window.addEventListener('scroll', this.handleScroll, true);
    // if (this.$router.history.current.name !== 'purchase' && JSON.parse(localStorage.getItem('showModalToken')) === true) { 
    //   this.toggleModal(true);
    // }
    this.$store.dispatch('auth/fetchCustomerInformation');
    // this.$store.dispatch('orders/fetchOrderByTimeFrame', 3);
    this.$nextTick(function() {
      this.changeCoordinateOfModal();
      this.handleWindowChange();
    })
    if(localStorage.Lang!=null) this.$i18n.locale=localStorage.Lang;
  },
  created() {
    window.addEventListener('resize', this.changeCoordinateOfModal);
    window.addEventListener('resize', this.handleWindowChange);
  },
  destroyed() {
    window.removeEventListener("resize", this.changeCoordinateOfModal);
    window.removeEventListener('resize', this.handleWindowChange);
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    homeWithinRadius: state => state.navbar.homeWithinRadius,
    homeRadiusChecked: state => state.navbar.homeRadiusChecked,
    checkoutWithinRadius: state => state.navbar.checkoutWithinRadius,
    checkoutRadiusChecked: state => state.navbar.checkoutRadiusChecked,
    showModal: state => state.navbar.showModal,
    // showModalToken: state => state.navbar.showModalToken,
    token: state => state.auth.token,
    mobile: state => state.navbar.mobile,
    windowWidth: state => state.navbar.windowWidth,
  }),
  watch: {
    showModal: function(newVal, oldVal) {
      if (newVal === true) {
        document.documentElement.style.overflow = 'hidden';
        return;
      } else {
        document.documentElement.style.overflow = 'auto'
      }
    },
    token: function(newVal, oldVal) {
      immediate: true;
      if (newVal !== null || newVal !== undefined) {
        this.local = false;
      } else {
        this.local = true;
      }
    },
  }
}
</script>

<style lang="less">
@import "../assets/css/navbar.less";
@import "../assets/css/public.less";
@import "../assets/css/cartContainer.less"; 

.unroll-enter-active, .unroll-leave-active {
  transition: opacity .5s;
}
.unroll-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.unroll-enter, .unroll-leave-to {
  opacity: 0;
}

.account-portal-modal {
  background-color: #f8f8f8;
  border-radius: 5px;
  width: 150px;
  text-align: center;
  padding: 15px;
  position: absolute;
  box-shadow: 1px 10px 15px rgba(0, 0, 0, 0.2);
  z-index: 7;
}

.modal-data-container {
  display: block;
  text-align: left;
  .usernameDisplayInBuble {
    color: grey;
    cursor: pointer;
    padding: 12px 0;
    font-size: 70%
  }

  .portal-links-container {
    padding-top: 10px;
    .each-link {
      line-height: 30px;
      cursor: pointer;
      .serviceText {
        .title-font(400; @black);
        font-size: 14px;
        text-overflow: ellipsis;
      }
    }
  }

  .logout {
    cursor: pointer;
    padding: 5px;
  }
}

.arrow {
  position: inherit;
  border-style: dashed;
  border-color: transparent;
  border-width: 0.20em;
  display: -moz-inline-box;
  display: inline-block;
  /* Use font-size to control the size of the arrow. */
  font-size: 50px;
  height: 0;
  line-height: 0;
  position: relative;
  vertical-align: middle;
  width: 0;
  background-color:transparent; /* change background color acc to bg color */ 
  border-bottom-width: 0.2em;
  border-bottom-style: solid;
  border-bottom-color: #f8f8f8;
  bottom:0.25em;
  top: -23px;
  left: 50px;
  z-index: inherit;
}

// .ui-select{width: 100%;}
// select::-ms-expand {	display: none; }
// select{
//     -webkit-appearance: none;
//     appearance: none;
// }
// @-moz-document url-prefix(){
// 	.ui-select{border: 1px solid #CCC; border-radius: 4px; box-sizing: border-box; position: relative; overflow: hidden;}
//   .ui-select select { width: 110%; background-position: right 30px center !important; border: none !important;}
// }
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue